import React, { useRef } from 'react';
import { useStoreon } from 'storeon/react';
import {
  Section,
  SectionSubTitle,
  ButtonWithGAClickButton,
  GalleryCatalog,
  GalleryOldCardContent,
  KitchenDownloadCatalog,
} from 'common/components';
import { useIntersection } from 'common/hooks';
import { COLLECTIONS_STORE_NAME, KitchenCollection, selectAvailableCollections } from 'modules/collections';
import { State } from 'store/types';
import { analyticsUtils } from 'utils/analytics-utils';
import { KITCHEN_ELEMENT_BLOCK } from '../../../kitchen-constants';
import { kitchenGalleryButton } from './kitchen-gallery-section-styles';

export const KitchenGallerySection = () => {
  const productRef = useRef<HTMLAnchorElement[]>([]);
  const { collections } = useStoreon<State>(COLLECTIONS_STORE_NAME);

  const collectionList = selectAvailableCollections(collections) as KitchenCollection[];

  useIntersection(productRef, el => {
    const position = el.getAttribute('data-position');

    if (!position) {
      return;
    }

    const numberPosition = Number(position);
    const collection = collectionList[numberPosition];

    analyticsUtils.sendEvent('GA:impressions', {
      elementType: 'product',
      elementBlock: `${KITCHEN_ELEMENT_BLOCK} / Catalog`,
      division: 'Кухни',
      subdivision: 'Проект кухни как пример',
      komplektyId: collection.productId,
      productName: collection.displayedName,
      productId: collection.productId,
      productPrice: collection.price,
      productPosition: numberPosition + 1,
      abTestPrice: null,
      productPrevPrice: null,
      productTag: undefined,
    });
  });

  const handleCardClick = (collection: KitchenCollection, position: number) => {
    analyticsUtils.sendEvent('GA:clickProduct', {
      elementType: 'product',
      elementBlock: `${KITCHEN_ELEMENT_BLOCK} / Catalog`,
      elementName: 'productNameLink',
      division: 'Кухни',
      subdivision: 'Проект кухни как пример',
      komplektyId: collection.productId,
      productName: collection.displayedName,
      productId: collection.productId,
      productPrice: collection.price,
      productPosition: position + 1,
      abTestPrice: null,
      productPrevPrice: null,
      productTag: undefined,
    });
  };

  if (collectionList.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionSubTitle margin="m">Каталог кухонь</SectionSubTitle>
      <GalleryCatalog
        catalog={collectionList}
        cardRefCb={(el: HTMLAnchorElement | null) => {
          const position = el?.getAttribute('data-position');
          if (position && el) {
            productRef.current[+position] = el;
          }
        }}
        renderCardContent={({ displayedName, price }) => <GalleryOldCardContent displayedName={displayedName} price={price} />}
        downloadCatalog={
          <KitchenDownloadCatalog
            elementBlock={KITCHEN_ELEMENT_BLOCK}
            elementText="Каталог кухонь"
          />
        }
        onCardClick={handleCardClick}
      />

      <ButtonWithGAClickButton
        className={kitchenGalleryButton}
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        elementName="Каталог кухонь"
        elementText="Перейти в каталог"
        href="/proekt-kuhni/na-zakaz/"
        title="Смотреть все стили кухонь"
        rounded>
        Перейти в каталог
      </ButtonWithGAClickButton>
    </Section>
  );
};
